/**
 * Returns a '-' (hyphen) when data is undefined or empty
 *
 * @param {string} value - the value which needs to be checked and replaced.
 * @returns {string} - (hyphen).
 */
export const formatEmptyData = (value?: string): string => {
  return value === undefined || value === '' ? '-' : value;
};
